export function AboutPage() {
  return (
    <main className="page page--narrow">
      <h1 style={{ fontFamily: 'var(--font-display)', letterSpacing: '-0.03em' }}>About 3DSpin</h1>
      <p style={{ lineHeight: 1.6 }}>
        3DSpin is where digital objects become collections, commerce and shared experiences. Create in your preferred tools.
        Inspect every surface. Choose clear rights. Bring your objects into worlds where people can enjoy them together.
      </p>

      <section id="dcommerce" style={{ marginTop: '2rem' }}>
        <h2 className="section-title">DCommerce</h2>
        <p className="muted" style={{ lineHeight: 1.6 }}>
          Digital goods commerce for immersive and compatible environments. Controlled use is the default delivery mode when enforcement is available.
          Export licenses are a separate seller election — never an automatic workaround for missing protected integration.
        </p>
      </section>

      <section id="community" style={{ marginTop: '2rem' }}>
        <h2 className="section-title">Community</h2>
        <p className="muted">Industry hubs, creators, and events — pilot cohorts forming. No fabricated user counts.</p>
      </section>

      <section id="help" style={{ marginTop: '2rem' }}>
        <h2 className="section-title">Help & support</h2>
        <p className="muted">Contact support through your organization administrator or project operator.</p>
      </section>

      <section id="terms" style={{ marginTop: '2rem' }}>
        <h2 className="section-title">Terms & policies</h2>
        <p className="muted">License guide, creator rights, and marketplace terms are published before live commerce (R3).</p>
      </section>

      <section id="privacy" style={{ marginTop: '2rem' }}>
        <h2 className="section-title">Privacy</h2>
        <p className="muted">Prompts, private filenames, and credentials are excluded from broad analytics.</p>
      </section>

      <section id="accessibility" style={{ marginTop: '2rem' }}>
        <h2 className="section-title">Accessibility</h2>
        <p className="muted">
          Core journeys target WCAG 2.2 AA with keyboard alternatives, visible focus, and poster fallbacks when live 3D preview is unavailable.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">Ecosystem</h2>
        <ul className="muted" style={{ lineHeight: 1.8 }}>
          <li><strong>Sansar</strong> — proposed first destination pilot; integration blocked pending verified contract.</li>
          <li><strong>Keyra</strong> — identity authority for protected use; dev and live adapters in repository.</li>
          <li><strong>Ciright</strong> — Core business contracts via api.ciright.com when enabled.</li>
        </ul>
      </section>
    </main>
  );
}
